import { TILE_LAYERS, TILE_LAYER_KEYS } from '@/services/map-tiles';
import type { TileLayerKey } from '@/services/map-tiles';

interface MapStyleSwitcherProps {
  active: TileLayerKey;
  onChange: (key: TileLayerKey) => void;
}

export function MapStyleSwitcher({ active, onChange }: MapStyleSwitcherProps) {
  return (
    <div
      style={{ zIndex: 1000 }}
      className="absolute bottom-10 right-2 flex flex-col gap-1 p-1 rounded-lg bg-[var(--color-surface)] border border-[var(--color-border)] shadow-[var(--shadow-card-md)]"
      role="group"
      aria-label="Map style"
    >
      {TILE_LAYER_KEYS.map((key) => {
        const isActive = key === active;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className={[
              'px-2 py-1 rounded text-body-xs font-medium transition-colors min-w-[52px] text-center',
              isActive
                ? 'bg-[var(--color-accent-subtle)] text-[var(--color-accent)] border border-[var(--color-accent)]'
                : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-elevated)] border border-transparent',
            ].join(' ')}
            aria-pressed={isActive}
          >
            {TILE_LAYERS[key].name}
          </button>
        );
      })}
    </div>
  );
}
